export const huifuList = ['huifucard','huifualipay','huifuwechat','huifu']